var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMore24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_more*24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99992 17.1668C9.54159 17.1668 9.14922 17.0036 8.82284 16.6772C8.49645 16.3509 8.33325 15.9585 8.33325 15.5002C8.33325 15.0418 8.49645 14.6495 8.82284 14.3231C9.14922 13.9967 9.54159 13.8335 9.99992 13.8335C10.4583 13.8335 10.8506 13.9967 11.177 14.3231C11.5034 14.6495 11.6666 15.0418 11.6666 15.5002C11.6666 15.9585 11.5034 16.3509 11.177 16.6772C10.8506 17.0036 10.4583 17.1668 9.99992 17.1668ZM9.99992 12.1668C9.54159 12.1668 9.14922 12.0036 8.82284 11.6772C8.49645 11.3509 8.33325 10.9585 8.33325 10.5002C8.33325 10.0418 8.49645 9.64947 8.82284 9.32308C9.14922 8.99669 9.54159 8.8335 9.99992 8.8335C10.4583 8.8335 10.8506 8.99669 11.177 9.32308C11.5034 9.64947 11.6666 10.0418 11.6666 10.5002C11.6666 10.9585 11.5034 11.3509 11.177 11.6772C10.8506 12.0036 10.4583 12.1668 9.99992 12.1668ZM9.99992 7.16683C9.54159 7.16683 9.14922 7.00363 8.82284 6.67725C8.49645 6.35086 8.33325 5.9585 8.33325 5.50016C8.33325 5.04183 8.49645 4.64947 8.82284 4.32308C9.14922 3.99669 9.54159 3.8335 9.99992 3.8335C10.4583 3.8335 10.8506 3.99669 11.177 4.32308C11.5034 4.64947 11.6666 5.04183 11.6666 5.50016C11.6666 5.9585 11.5034 6.35086 11.177 6.67725C10.8506 7.00363 10.4583 7.16683 9.99992 7.16683Z",
    fill: "#BCB8C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore24);
export default __webpack_public_path__ + "static/media/ic_more_24.a1e1a9648733c942609797d1a6bf0a27.svg";
export { ForwardRef as ReactComponent };